// Stub for useAwaitQuery hook
import { useCallback } from 'react';

export function useAwaitQuery(query) {
    const runQuery = useCallback(async () => {
        console.warn('useAwaitQuery stub - not implemented');
        return { data:null, error: null };
    }, [query]);

    return runQuery;
}
